import {useQuery} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

export function useB2BAgencyStats(agencyId: string, isSelfService = false) {
    const query = useQuery({
        queryKey: ['b2b-agency-stats', agencyId],
        queryFn: () => b2bMetricsRepository.getB2BAgencyStats(agencyId, isSelfService),
        enabled: !!agencyId,
    })

    return {
        stats: query.data,
        isLoadingStats: query.isLoading,
        statsError: query.error,
    }
}
